import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { CircularProgress, Box } from '@mui/material';

const AdminRoute = () => {
  const { isSysAdmin, loading } = usePermissions();
  
  // Aguardar o carregamento das permissões antes de verificar
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  
  return isSysAdmin() ? <Outlet /> : <Navigate to="/home" />;
};

export default AdminRoute;

